import React, { useState } from "react";
import styles from "./css/Contacts.module.css";
import { TextField } from "@mui/material";
import sendEmail from "../../emailutil"; // Importing the sendEmail function
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify"; // Update this import
import "react-toastify/dist/ReactToastify.css"; // Add this import

const Contacts = () => {
  // State for each form field
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [comment, setComment] = useState("");

  const language = useSelector((state: any) => state.language.value);

  // Translations
  const translations = {
    contact: language === "RO" ? "Contact" : "Contact",
    namePlaceholder: language === "RO" ? "Nume" : "Name",
    emailPlaceholder: language === "RO" ? "Email" : "Email",
    phonePlaceholder: language === "RO" ? "Număr de telefon" : "Phone number",
    commentPlaceholder: language === "RO" ? "Comentariu" : "Comment",
    sendButton: language === "RO" ? "Trimite email" : "Send email",
  };

  // Add validation functions
  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isValidPhone = (phone: string) => {
    const phoneRegex = /^\+?[\d\s-]{8,}$/;
    return phoneRegex.test(phone);
  };

  // Handle form submission
  const handleSendEmail = async () => {
    // Validation checks
    if (!name || !email || !phone || !comment) {
      toast.error(
        language === "RO"
          ? "Toate câmpurile sunt obligatorii!"
          : "All fields are required!"
      );
      return;
    }

    if (!isValidEmail(email)) {
      toast.error(
        language === "RO"
          ? "Adresa de email nu este validă!"
          : "Please enter a valid email address!"
      );
      return;
    }

    if (!isValidPhone(phone)) {
      toast.error(
        language === "RO"
          ? "Numărul de telefon nu este valid!"
          : "Please enter a valid phone number!"
      );
      return;
    }

    try {
      const emailData = {
        userEmail: email,
        itemName: "Contact Form Submission",
        subject: "New Contact Form Submission",
        message: `Name: ${name}<br>Email: ${email}<br>Phone: ${phone}<br>Comment: ${comment}`,
        name: name,
        phone: phone,
        comment: comment,
        recepient: "dax0068@gmail.com",
      };

      await sendEmail(emailData);

      // Only clear form and show success if the email was sent successfully
      setName("");
      setEmail("");
      setPhone("");
      setComment("");

      toast.success(
        language === "RO"
          ? "Email trimis cu succes!"
          : "Email sent successfully!"
      );
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error(
        language === "RO"
          ? "Eroare la trimiterea emailului. Vă rugăm încercați din nou."
          : "Error sending email. Please try again."
      );
    }
  };

  return (
    <div>
      <ToastContainer />
      <div className={styles.productContainer}>
        <div className={styles.productInfo}>
          <div className={styles.frame}>
            <span className={styles.productTitle7}>{translations.contact}</span>
            <div className={styles.form}>
              <div
                className={styles.inputs}
                style={{ gap: "5px", display: "flex" }}
              >
                <div className={styles.inputField} style={{ flex: 1 }}>
                  <TextField
                    sx={{
                      width: "100%",
                      height: "inherit",
                      "& .MuiFilledInput-root": {
                        height: "inherit",
                      },
                    }}
                    hiddenLabel
                    id="name"
                    placeholder={translations.namePlaceholder}
                    variant="filled"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className={styles.inputField} style={{ flex: 1 }}>
                  <TextField
                    sx={{
                      width: "100%",
                      height: "inherit",
                      "& .MuiFilledInput-root": {
                        height: "inherit",
                      },
                    }}
                    hiddenLabel
                    id="email"
                    placeholder={translations.emailPlaceholder}
                    variant="filled"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className={styles.inputField9}>
                <div className={styles.inputFieldA}>
                  <TextField
                    sx={{
                      width: "100%",
                      height: "inherit",
                      "& .MuiFilledInput-root": {
                        height: "inherit",
                      },
                    }}
                    hiddenLabel
                    id="phone"
                    placeholder={translations.phonePlaceholder}
                    variant="filled"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
              </div>
              <div className={styles.inputFieldC}>
                <div className={styles.inputsD}>
                  <TextField
                    sx={{
                      width: "100%",
                      height: "150px",
                      "& .MuiFilledInput-root": {
                        height: "inherit",
                        backgroundColor: "transparent",
                        border: "1px solid #c4b57c",
                        borderRadius: "2px",
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                        "&.Mui-focused": {
                          backgroundColor: "transparent",
                        },
                      },
                      "& .MuiInputBase-input": {
                        // fontFamily: "Lora, serif",
                        fontSize: "17px",
                        color: "#3a382f",
                      },
                      "& textarea": {
                        resize: "vertical !important",
                        minHeight: "100px !important",
                        maxHeight: "400px !important",
                      },
                      "& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after":
                        {
                          display: "none",
                        },
                    }}
                    hiddenLabel
                    id="comment"
                    placeholder={translations.commentPlaceholder}
                    variant="filled"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    multiline
                    rows={1}
                  />
                </div>
              </div>
            </div>
            <button className={styles.buttonE} onClick={handleSendEmail}>
              <span className={styles.addToCartF}>
                {translations.sendButton}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
